import React, { useEffect, useContext, useState, useRef } from "react";
import { TokenVerificationLoggedin, BlockAdmin } from "../../../utils/tokenVerify";
import { LoadingContext } from "react-router-loading";
import axios from "axios";
import Cookies from "js-cookie";
import configData from "../../../config/config.json";
import { Table, Tooltip, Select, Col, Row, Pagination, Input, Radio, Checkbox } from 'antd';
import { Link } from 'react-router-dom'
import FullLoader from "../../../assets/images/full-page-loader.gif"
import prevIcon from '../../../assets/images/icons/chevron-left.svg';
import nextIcon from '../../../assets/images/icons/chevron-right.svg';
import noData from '../../../assets/images/data-graph/no-data.svg';
import TableLoader from "../../TableLoader";
import errorData from '../../../assets/images/data-graph/error-data.svg';
import { notifyfailure, notifysuccess, notifycatch } from "../../../utils/toast";
import zoneIcon from '../../../assets/images/icons/zone.svg';
import backButton from '../../../assets/images/back_button_arrow.svg';
import AddCodesAdd from '../../../assets/images/icons/add_codes_add.svg';
import AddCodesMinus from '../../../assets/images/icons/ad_codes_minus.svg';
import deleteIcon from '../../../assets/images/icons/delete_icon.svg';
import loaderIcon from "../../../assets/images/login-and-signup/loader.gif";

const CTVConfigureAdcodes = ({ handlePageViewChange }) => {

    const loadingContext = useContext(LoadingContext);
    const [apiCall, setApicall] = useState(false)
    const [tabView, setTabView] = useState(0)

    const getStatusColumnWidth = () => {
        const ratio = window.devicePixelRatio;
        if (ratio >= 1.25) {
            return 46; // for 125% zoom
        } else {
            return 39; // default
        }
    };

    const getNameColumnWidth = () => {
        const ratio = window.devicePixelRatio;
        if (ratio >= 1.25) {
            return 104; // for 125% zoom
        } else {
            return 111; // default
        }
    };


    const columnsAdDomain = [

        {
            title: "Name",
            dataIndex: "name",
            key: "name",
            sortDirections: ['ascend', 'descend', 'ascend'],
            sorter: false,
            fixed: 'left',
            width: getNameColumnWidth(),
            // render: (text) => <div style={{ paddingTop: '4px' }}>{text}</div>
            render: (data, record) => {
                return (
                    <>
                        {(data === "" || data === "-" || data === undefined || data === null) ? <><div className='text_dark'>-</div></> :
                            data.length >= 33 ?
                                <Tooltip title={data}><div className='text_ellipsis d-block' style={{ cursor: "pointer", paddingTop: '4px' }}>{data.slice(0, 33)}...</div></Tooltip>
                                :
                                <div className='text_ellipsis d-block' style={{ paddingTop: '4px' }} >{data}</div>

                        }
                    </>
                )
            }
        },
        {
            title: "",
            dataIndex: "status",
            key: "status",
            sortDirections: ['ascend', 'descend', 'ascend'],
            sorter: false,
            fixed: 'left',
            width: getStatusColumnWidth(),
            render: (text, record) => <div className='w_100 position-relative' style={{ paddingTop: '4px' }}>
                <Select
                    className={text === "enable" ? "form_select badge_content--approved" : "form_select badge_content--declined"}
                    dropdownStyle={{
                        width: '12rem'
                    }}
                    value={text}
                    options={
                        [{ label: "Enabled", value: "enable" }, { label: "Disabled", value: "disable" }]
                    }
                    onChange={(event) => {

                        let status = Cookies.get("token_xapads_ssp") ? true : false;
                        if (status) {
                            let token = Cookies.get("token_xapads_ssp");

                            let payload = {
                                "status": event,
                                "_id": record?._id,
                            }

                            setLoading(true)
                            axios
                                .post(configData.SERVER_URL + `ctv/update?tab=${tabView}`, payload, {
                                    headers: {
                                        "Content-Type": "application/json",
                                        "x-access-token": token,
                                    },
                                })
                                .then((response) => {
                                    getData(tabView)
                                    notifysuccess(response.data.message);

                                })
                                .catch((error) => {
                                    if (error.response.data.message?.length !== 0) {
                                        notifyfailure(error.response.data.message)
                                    }
                                    else {
                                        notifycatch()
                                    }
                                    setLoading(false)

                                });

                        }
                    }
                    }
                />

            </div>,

        },
        {
            title: "Adcodes",
            dataIndex: "adcodes",
            width: 450,
            key: "adcodes",
            sortDirections: ['ascend', 'descend', 'ascend'],
            sorter: false,
            render: (text) => {

                if (!Array.isArray(text)) {
                    text = []
                }

                return (
                    <div style={{ paddingTop: '4px' }} >
                        {(text.length === 0) ?
                            <>
                                <div className='text_dark'>-</div>
                            </>
                            :
                            <>

                                {text?.map((item, index) => (
                                    <>
                                        <span className="adocde_span_design" key={index} style={{ marginRight: "8px" }}>
                                            <Tooltip title={item.condition === "" ? "case insensitive" : item.condition}>
                                                {item.value}
                                            </Tooltip>
                                        </span>
                                        {index !== text.length - 1 && <span>,</span>}
                                    </>
                                ))}

                            </>

                        }
                    </div>
                )
            },
        },

    ]
    const columnsOwnerDomain = [

        {
            title: "Name",
            dataIndex: "name",
            key: "name",
            sortDirections: ['ascend', 'descend', 'ascend'],
            sorter: false,
            fixed: 'left',
            width: getNameColumnWidth(),
            // render: (text) => <div style={{ paddingTop: '5px' }}>{text}</div>
            render: (data, record) => {
                return (
                    <>
                        {(data === "" || data === "-" || data === undefined || data === null) ? <><div className='text_dark'>-</div></> :
                            data.length >= 33 ?
                                <Tooltip title={data}><div className='text_ellipsis d-block' style={{ cursor: "pointer", paddingTop: '4px' }}>{data.slice(0, 33)}...</div></Tooltip>
                                :
                                <div className='text_ellipsis d-block' style={{ paddingTop: '4px' }} >{data}</div>

                        }
                    </>
                )
            }
        },
        {
            title: "",
            dataIndex: "status",
            key: "status",
            sortDirections: ['ascend', 'descend', 'ascend'],
            sorter: false,
            fixed: 'left',
            width: getStatusColumnWidth(),
            render: (text, record) => <div className='w_100 position-relative' style={{ paddingTop: '4px' }}>
                <Select
                    className={text === "enable" ? "form_select badge_content--approved" : "form_select badge_content--declined"}
                    dropdownStyle={{
                        width: '12rem'
                    }}
                    value={text}
                    options={
                        [{ label: "Enabled", value: "enable" }, { label: "Disabled", value: "disable" }]
                    }
                    onChange={(event) => {

                        let status = Cookies.get("token_xapads_ssp") ? true : false;
                        if (status) {
                            let token = Cookies.get("token_xapads_ssp");

                            let payload = {
                                "status": event,
                                "_id": record?._id,
                            }

                            setLoading(true)
                            axios
                                .post(configData.SERVER_URL + `ctv/update?tab=${tabView}`, payload, {
                                    headers: {
                                        "Content-Type": "application/json",
                                        "x-access-token": token,
                                    },
                                })
                                .then((response) => {
                                    getData(tabView)
                                    notifysuccess(response.data.message);

                                })
                                .catch((error) => {
                                    if (error.response.data.message?.length !== 0) {
                                        notifyfailure(error.response.data.message)
                                    }
                                    else {
                                        notifycatch()
                                    }
                                    setLoading(false)

                                });

                        }
                    }
                    }
                />

            </div>,

        },
        {
            title: "Owner Domain",
            dataIndex: "adcodes",
            width: 450,
            key: "adcodes",
            sortDirections: ['ascend', 'descend', 'ascend'],
            sorter: false,
            render: (text) => {

                if (!Array.isArray(text)) {
                    text = []
                }

                return (
                    <div style={{ paddingTop: '4px' }}>
                        {(text.length === 0) ?
                            <>
                                <div className='text_dark'>-</div>
                            </>
                            :
                            <>

                                {text?.map((item, index) => (
                                    <>
                                        <span className="adocde_span_design" key={index} style={{ marginRight: "8px" }}>
                                            <Tooltip title={item.condition === "" ? "case insensitive" : item.condition}>
                                                {item.value}
                                            </Tooltip>
                                        </span>
                                        {index !== text.length - 1 && <span>,</span>}
                                    </>
                                ))}

                            </>

                        }
                    </div>
                )
            },
        },

    ]
    const columnsPartnerDomain = [

        {
            title: "Name",
            dataIndex: "name",
            key: "name",
            sortDirections: ['ascend', 'descend', 'ascend'],
            sorter: false,
            fixed: 'left',
            width: getNameColumnWidth(),
            // render: (text) => <div style={{ paddingTop: '5px' }}>{text}</div>
            render: (data, record) => {
                return (
                    <>
                        {(data === "" || data === "-" || data === undefined || data === null) ? <><div className='text_dark'>-</div></> :
                            data.length >= 33 ?
                                <Tooltip title={data}><div className='text_ellipsis d-block' style={{ cursor: "pointer", paddingTop: '4px' }}>{data.slice(0, 33)}...</div></Tooltip>
                                :
                                <div className='text_ellipsis d-block' style={{ paddingTop: '4px' }} >{data}</div>

                        }
                    </>
                )
            }
        },
        {
            title: "",
            dataIndex: "status",
            key: "status",
            sortDirections: ['ascend', 'descend', 'ascend'],
            sorter: false,
            fixed: 'left',
            width: getStatusColumnWidth(),
            render: (text, record) => <div className='w_100 position-relative' style={{ paddingTop: '4px' }}>
                <Select
                    className={text === "enable" ? "form_select badge_content--approved" : "form_select badge_content--declined"}
                    dropdownStyle={{
                        width: '12rem'
                    }}
                    value={text}
                    options={
                        [{ label: "Enabled", value: "enable" }, { label: "Disabled", value: "disable" }]
                    }
                    onChange={(event) => {

                        let status = Cookies.get("token_xapads_ssp") ? true : false;
                        if (status) {
                            let token = Cookies.get("token_xapads_ssp");

                            let payload = {
                                "status": event,
                                "_id": record?._id,
                            }

                            setLoading(true)
                            axios
                                .post(configData.SERVER_URL + `ctv/update?tab=${tabView}`, payload, {
                                    headers: {
                                        "Content-Type": "application/json",
                                        "x-access-token": token,
                                    },
                                })
                                .then((response) => {
                                    getData(tabView)
                                    notifysuccess(response.data.message);

                                })
                                .catch((error) => {
                                    if (error.response.data.message?.length !== 0) {
                                        notifyfailure(error.response.data.message)
                                    }
                                    else {
                                        notifycatch()
                                    }
                                    setLoading(false)

                                });

                        }
                    }
                    }
                />

            </div>,

        },
        {
            title: "Inventory Partner Domain",
            dataIndex: "adcodes",
            width: 450,
            key: "adcodes",
            sortDirections: ['ascend', 'descend', 'ascend'],
            sorter: false,
            render: (text) => {

                if (!Array.isArray(text)) {
                    text = []
                }

                return (
                    <div style={{ paddingTop: '4px' }} >
                        {(text.length === 0) ?
                            <>
                                <div className='text_dark'>-</div>
                            </>
                            :
                            <>

                                {text?.map((item, index) => (
                                    <>
                                        <span className="adocde_span_design" key={index} style={{ marginRight: "8px" }}>
                                            <Tooltip title={item.condition === "" ? "case insensitive" : item.condition}>
                                                {item.value}
                                            </Tooltip>
                                        </span>
                                        {index !== text.length - 1 && <span>,</span>}
                                    </>
                                ))}

                            </>

                        }
                    </div>
                )
            },
        },

    ]

    // const [data, setData] = useState([])
    const [data, setData] = useState([])

    const [loading, setLoading] = useState(true)
    const [initialLoad, setInitialLoad] = useState(true)
    const [search, setSearch] = useState("")

    const tableRef = useRef(null);
    const scrollToTop = () => {
        const tableBody = tableRef.current?.querySelector(".ant-table-body");
        if (tableBody) {
            tableBody.scrollTop = 0;
        }
    };

    useEffect(() => {
        if (!initialLoad) {
            getData()
        }
    }, [apiCall])

    function onChangeTabChangeMain(data) {
        setSearch("")
        setInitialLoad(true)
        resetFilterOnTabChange()
        setTabView(data)
        getData(data)

    }

    const getData = (tab) => {
        setLoading(true)
        let status = Cookies.get("token_xapads_ssp") ? true : false;
        if (status) {
            let token = Cookies.get("token_xapads_ssp");
            // axios
            //     .get(configData.SERVER_URL + `adcodes/list?sort=${sort.name}&order=${sort.type}&search=${search}&limit=${page.pageSize}&page=${page.current}`, {
            //         headers: {
            //             "Content-Type": "application/json",
            //             "x-access-token": token,
            //         },
            //     })
            //     .then((response) => {
            //         setData(response.data.data.data)

            //         if (response.data.data.data.length > 0) {
            //             let tempPage = { ...page }
            //             tempPage.total = response.data.data.metaData?.totalRecords

            //             setPage(tempPage)
            //         }

            //         // setLoading(false)
            //         setInitialLoad(false)
            //     })
            //     .catch((error) => {
            //         // setData([])

            //         // setLoading(false)
            //         setInitialLoad(false)
            //     });


            let tempTab = 0
            if (tab !== "") {
                tempTab = tab
            }

            axios
                .get(configData.SERVER_URL + `ctv/list?tab=${tempTab}`, {
                    headers: {
                        "Content-Type": "application/json",
                        "x-access-token": token,
                    },
                })
                .then((response) => {
                    setData(response.data.data)
                    setInitialLoad(false)
                    setLoading(false)
                    scrollToTop()
                })
                .catch((error) => {
                    // setData([])
                    setInitialLoad(false)
                    setLoading(false)
                });


        }

    }

    useEffect(() => {
        TokenVerificationLoggedin();
        BlockAdmin()
        getData("")
        loadingContext.done()
    }, [loadingContext]);


    const itemRender = (current, type, originalElement) => {
        if (type === 'prev') {
            return <Link><img src={prevIcon} alt='USP' /></Link>;
        }
        if (type === 'next') {
            return <Link><img src={nextIcon} alt='USP' /></Link>;
        }
        return originalElement;
    };


    const locale = {
        emptyText:
            <>
                {

                    search.trim().length > 0 && loading ?
                        <div className='no_data_screen'>
                            <div className='text-center'>

                                <div className='float_text_div'>

                                </div>
                            </div>
                        </div>
                        :
                        search.trim().length > 0 && !loading ?
                            <div className='no_data_screen'>
                                <div className='text-center'>
                                    <img src={errorData} className='' alt="" />
                                    <div className='float_text_div'>

                                    </div>
                                </div>
                            </div>
                            :

                            loading ?
                                <div className='no_data_screen'>
                                    <div className='text-center'>

                                        <div className='float_text_div'>

                                        </div>
                                    </div>
                                </div>
                                :
                                <div className='no_data_screen' >
                                    <div className='text-center'>
                                        <img src={noData} className='' alt="" />
                                        <div className='float_text_div'>

                                        </div>
                                    </div>
                                </div>
                }
            </>

    };



    // ////////////////////////////filter repeater related code/////////////////////////////////////////////////////

    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");

    function handleDynamicWidthInput(id, value) {
        const input = document.getElementById(id);
        if (!input) return;

        const style = window.getComputedStyle(input);
        const font = `${style.fontWeight} ${style.fontSize} ${style.fontFamily}`;
        context.font = font;
        const textWidth = context.measureText(value || input.placeholder || "").width;

        let minWidth
        if (id === "width_adcode_0") {
            minWidth = 18.3 * 10;
        }
        else {
            minWidth = 14.2 * 10;
        }
        // 14.2rem to px (assuming 16px base font)
        const maxWidth = 350; // max width in px
        const padding = 16; // estimated padding left + right

        const totalWidth = Math.min(Math.max(textWidth + padding, minWidth), maxWidth);
        input.style.width = totalWidth + "px";
    }


    const [buttonProcessingCheckAdcodes, setButtonProcessingCheckAdcodes] = useState(false)
    const [filterCheckAdcodesName, setFilterCheckAdcodesName] = useState("");
    const [filterCheckAdcodesNameIsRequiredError, setFilterCheckAdcodesNameIsRequiredError] = useState(false)
    const [filterCheckAdcodesNameValueError, setFilterCheckAdcodesNameValueError] = useState(false)

    function resetFilterOnTabChange() {
        setButtonProcessingCheckAdcodes(false)
        setFilterCheckAdcodesName("")
        setFilterCheckAdcodesNameIsRequiredError(false)
        setFilterCheckAdcodesNameValueError(false)
        setFilterCheckAdcodes([{
            value: "", condition: "",
            validation: false
        }])
        setFilterCheckAdcodesIsRequiredError(false)
        setFilterCheckAdcodesValidError(false)

    }

    function handleFilterCheckAdCodesName(event) {
        setFilterCheckAdcodesNameIsRequiredError(false)
        setFilterCheckAdcodesNameValueError(false)
        if (event.target.value.trim().length > 0) {
            if (/^[a-zA-Z0-9_]+$/.test(event.target.value.trim())) {
                setFilterCheckAdcodesName(event.target.value.trim())
            }
        }
        else {
            setFilterCheckAdcodesName(event.target.value.trim())
        }
    }

    const [filterCheckAdcodes, setFilterCheckAdcodes] = useState([{
        value: "", condition: "",
        validation: false,
        valid: false,
    }]);

    const [filterCheckAdcodesIsRequiredError, setFilterCheckAdcodesIsRequiredError] = useState(false)
    const [filterCheckAdcodesValidError, setFilterCheckAdcodesValidError] = useState(false)

    function handleFilterCheckAdCodesValue(event, id, index) {
        setFilterCheckAdcodesIsRequiredError(false)
        setFilterCheckAdcodesValidError(false)

        let conditionCheck = { ...filterCheckAdcodes[index] }
        const inputValue = event.target.value.replace(/,/g, '').trim();

        const tempFilterCheckAdcodes = [...filterCheckAdcodes];
        tempFilterCheckAdcodes[index].value = inputValue
        tempFilterCheckAdcodes[index].validation = false
        tempFilterCheckAdcodes[index].valid = false
        if (inputValue === "") {
            tempFilterCheckAdcodes[index].condition = ""
        }
        else {
            if (tabView === 0) {
                if (((!isNaN(inputValue) && !isNaN(parseFloat(inputValue))) && (conditionCheck.value === "" && inputValue !== ""))
                ) {
                    tempFilterCheckAdcodes[index].condition = "direct"
                }
                else if (!(!isNaN(inputValue) && !isNaN(parseFloat(inputValue))) && (conditionCheck.condition === "regex" || conditionCheck.condition === "direct")) {
                    tempFilterCheckAdcodes[index].condition = ""
                }
                else if (((!isNaN(inputValue) && !isNaN(parseFloat(inputValue))) && (conditionCheck.condition === "" || conditionCheck.condition === "case sensitive"))
                ) {
                    tempFilterCheckAdcodes[index].condition = "direct"
                }
            }
        }

        // tempFilterCheckAdcodes[index].condition = inputValue == "" ? "" : tempFilterCheckAdcodes[index].condition
        setFilterCheckAdcodes(tempFilterCheckAdcodes)

        if (tabView === 0) {
            handleDynamicWidthInput(id, inputValue)
        }

    }

    function handleFilterCheckAdCodesCondition(event, type, index) {
        setFilterCheckAdcodesIsRequiredError(false)
        setFilterCheckAdcodesValidError(false)
        const tempFilterCheckAdcodes = [...filterCheckAdcodes];

        if (type === "radio") {
            tempFilterCheckAdcodes[index].condition = event.target.value
        }
        if (type === "checkbox") {
            tempFilterCheckAdcodes[index].condition = event.target.checked ? "case sensitive" : ""

        }
        tempFilterCheckAdcodes[index].validation = false
        tempFilterCheckAdcodes[index].valid = false

        setFilterCheckAdcodes(tempFilterCheckAdcodes)
    }

    function addFilterCheckAdCodes() {

        let tempFilterCheckAdcodes = [...filterCheckAdcodes]
        tempFilterCheckAdcodes.push({
            value: "",
            condition: "",
            validation: false,
            valid: false,
        })

        setFilterCheckAdcodes(tempFilterCheckAdcodes)

    }

    const removeFilterCheckAdCodes = (index) => {
        setFilterCheckAdcodesIsRequiredError(false)
        setFilterCheckAdcodesValidError(false)
        let tempFilterCheckAdcodes = [...filterCheckAdcodes];
        tempFilterCheckAdcodes.splice(index, 1);
        setFilterCheckAdcodes(tempFilterCheckAdcodes);
    };

    const validateFilterCheckAdcodes = () => {
        if (tabView === 0) {
            let allValuesValid = true;
            setFilterCheckAdcodes(prevFilterRepeater =>
                prevFilterRepeater.map(item => {
                    let isValueEmpty;

                    isValueEmpty = item.value.trim().length === 0;

                    if (isValueEmpty) {
                        allValuesValid = false;
                    }
                    return {
                        ...item,
                        validation: isValueEmpty,
                    };
                })
            );

            if (!allValuesValid) {
                setFilterCheckAdcodesIsRequiredError(true)
            }
            return allValuesValid;
        }
        else {
            let allValuesValid = true;
            let allDomainValid = true;

            setFilterCheckAdcodes(prevFilterRepeater =>
                prevFilterRepeater.map(item => {
                    let isValueEmpty;
                    let isValidDomain;

                    isValueEmpty = item.value.trim().length === 0;

                    isValidDomain = /.+[.].+/.test(item.value);

                    if (isValueEmpty) {
                        allValuesValid = false;
                    }
                    if (!isValidDomain) {
                        allDomainValid = false;
                    }
                    return {
                        ...item,
                        validation: isValueEmpty,
                        valid: !isValidDomain
                    };
                })
            );

            if (!allValuesValid) {
                setFilterCheckAdcodesIsRequiredError(true)
            }
            else if (!allDomainValid) {
                setFilterCheckAdcodesValidError(true)
            }
            return (allValuesValid && allDomainValid);

        }
    };

    function validateFilterCheckAdcodesNameUnique(check, data) {
        return data.some(obj => obj.name?.toLowerCase() === check?.toLowerCase());
    }

    const handleSubmitCheckAdcodes = () => {
        if (
            filterCheckAdcodesName !== ""
        ) {
            if (
                filterCheckAdcodesNameIsRequiredError === false &&
                filterCheckAdcodesValidError === false &&
                filterCheckAdcodesNameValueError === false
            ) {

                if (validateFilterCheckAdcodes()) {


                    if (validateFilterCheckAdcodesNameUnique(filterCheckAdcodesName, data)) {
                        setFilterCheckAdcodesNameValueError(true)
                        return
                    }
                    setButtonProcessingCheckAdcodes(true)

                    let formData = new FormData();

                    formData.append("name", filterCheckAdcodesName);
                    formData.append("adcodes", JSON.stringify(filterCheckAdcodes.map(({ value, condition, ...rest }) => ({ value, condition }))));


                    let status = Cookies.get("token_xapads_ssp") ? true : false;
                    if (status) {

                        let token = Cookies.get("token_xapads_ssp");

                        axios
                            .post(configData.SERVER_URL + `ctv/add?tab=${tabView}`, formData, {
                                headers: {
                                    "Content-Type": "multipart/form-data",
                                    "x-access-token": token,
                                }
                            }
                            )
                            .then((response) => {
                                notifysuccess(response.data.message)
                                // setApicall(!apiCall)
                                // setIsModalVisible(false)
                                // resetStatesCheckAdcodes()

                                getData(tabView)
                                resetFilterOnTabChange()
                                setButtonProcessingCheckAdcodes(false)
                            })
                            .catch((error) => {
                                if (error?.response) {
                                    if (error.response.data.message?.length !== 0) {
                                        notifyfailure(error.response.data.message);
                                    }
                                } else {
                                    notifycatch();
                                }
                                setButtonProcessingCheckAdcodes(false)

                            });


                    }
                }
            }
        } else {

            if (filterCheckAdcodesName === "") {
                validateFilterCheckAdcodes()
                setFilterCheckAdcodesNameIsRequiredError(true);

            }
        }


    };

    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    return (
        <>


            <div className="container_box--wrapper pt_header"
            >
                <div className="container_box--breadcrumb">
                    <ul className="container_box--breadcrumb-list">
                        <li>
                            <Link onClick={() => {
                                handlePageViewChange("table", "yes")
                            }}>
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M2.16667 12.5L13.8333 12.5C14.4777 12.5 15 11.9528 15 11.2778L15 2.72222C15 2.04721 14.4777 1.5 13.8333 1.5L2.16667 1.5C1.52234 1.5 1 2.04721 1 2.72222L1 11.2778C1 11.9528 1.52234 12.5 2.16667 12.5Z" stroke="#98A2B3" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M10 14.5H6" stroke="#98A2B3" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M10 7L7 4.5V9.5L10 7Z" stroke="#98A2B3" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>

                                CTV
                            </Link>
                        </li>
                        <li className="primary">Configure Adcodes</li>
                    </ul>
                </div>
                <div className="container_box--wrapper--title"
                    style={{ paddingBottom: "0px" }}
                >
                    <div className="back_btn_d2">
                        <img src={backButton} className="img-fluid" alt=""
                            onClick={() => {
                                handlePageViewChange("table", "yes")
                            }}
                        />
                        <h1 className="heading">
                            Configure Adcodes
                        </h1>
                    </div>
                    <div className="w-50 edit_campaign_page_d2">
                        <div className="tab_content--buttons">

                            <button className={tabView === 0 ? 'btn active' : "btn"} disabled={initialLoad} onClick={() => {
                                if (tabView !== 0) {
                                    onChangeTabChangeMain(0)
                                }

                            }} >
                                Adcodes
                            </button>

                            <button className={tabView === 1 ? 'btn active' : "btn"} disabled={initialLoad} onClick={() => {
                                if (tabView !== 1) {
                                    onChangeTabChangeMain(1)
                                }
                            }}>
                                Owner Domain
                            </button>

                            <button className={tabView === 2 ? 'btn active' : "btn"} disabled={initialLoad} onClick={() => {
                                if (tabView !== 2) {
                                    onChangeTabChangeMain(2)
                                }
                            }}>
                                Inventory Partner Domain
                            </button>


                        </div>
                    </div>
                </div>

                <div className="table_and_filter_div --without_filter_div" style={{ height: 'calc(100dvh - 24.9rem)' }}>
                    <div className="table_area_div">
                        <div className="searchbar_with_btns">
                            <div className="d_flex justify_content_between">
                                <div className="form_content_block--group">
                                    {!initialLoad &&
                                        <Input
                                            type='text'
                                            className='form_control basic md search_input w_table_search'
                                            placeholder="Search"
                                            value={search}
                                            onChange={(e) => {

                                                // if (e.target.value.trim().length === 0) {
                                                //     setLoading(true)
                                                // }

                                                setSearch(e.target.value)
                                            }}
                                        />
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="table_content--box --new_layout_table_design table_empty_screen_d2 table_ctv_planner">
                            {loading && !initialLoad &&
                                <div className="table_new_loader_d2 "
                                    style={{ height: "70vh" }}
                                >
                                    <img src={FullLoader} className="img-fluid" alt="" />
                                </div>

                            }

                            {initialLoad ?
                                <TableLoader />

                                :
                                <>

                                    <div className="ctv_repeater_container">
                                        <div className="header">

                                            <div className="first_container">Name</div>
                                            {tabView === 0 ?
                                                <div className="second_container">Adcodes</div> :
                                                tabView === 1 ?
                                                    <div className="second_container">Owner Domain</div> :
                                                    <div className="second_container">Inventory Partner Domain</div>
                                            }


                                        </div>

                                        <div className="repeater">
                                            <div className="first_container">
                                                <div className="form_content_block--group input_block" >

                                                    <Input
                                                        className={(filterCheckAdcodesNameIsRequiredError || filterCheckAdcodesNameValueError) ? "form_control basic error" : "form_control basic"}
                                                        value={filterCheckAdcodesName}
                                                        onChange={handleFilterCheckAdCodesName}
                                                        placeholder="Enter Name"
                                                        autocomplete="off"
                                                    />

                                                    {filterCheckAdcodesNameIsRequiredError && (
                                                        <span className="error_content error_content_adjust"
                                                        > This field is required</span>
                                                    )}
                                                    {filterCheckAdcodesNameValueError && (
                                                        <span className="error_content error_content_adjust"
                                                        > Name must be unique</span>
                                                    )}

                                                </div>

                                            </div>

                                            <div className="second_container ">
                                                <div className="d_flex">
                                                    <div className="check_adcodes_custom_input ">
                                                        <div className="d_flex flex_wrap">
                                                            {filterCheckAdcodes.map((item, index) => (
                                                                <React.Fragment key={index}>

                                                                    {index > 0 &&

                                                                        <div className="comma_container">
                                                                            <span className="comma">,</span>
                                                                        </div>
                                                                    }

                                                                    <div className="d_flex flex_column">
                                                                        <div className="position">
                                                                            <Input
                                                                                id={`width_adcode_${index}`}
                                                                                className={(tabView !== 0 && !item.validation && !item.valid) ? "check_adcode_input second" :
                                                                                    (tabView !== 0 && (item.validation || item.valid)) ? "check_adcode_input second error " :
                                                                                        (item.validation || item.valid) ? "check_adcode_input error" : "check_adcode_input"}
                                                                                value={item.value}
                                                                                onChange={(event) => { handleFilterCheckAdCodesValue(event, `width_adcode_${index}`, index) }}
                                                                                placeholder={index === 0 ? "dailymotion.com" : ""}
                                                                                autocomplete="off"
                                                                            />
                                                                            {index > 0 &&
                                                                                <img className="check_adcodes_minus" src={AddCodesMinus} alt=""
                                                                                    onClick={() => { removeFilterCheckAdCodes(index) }}

                                                                                />
                                                                            }
                                                                        </div>
                                                                        {item.value.length > 0 &&
                                                                            <>
                                                                                {tabView === 0 ?
                                                                                    <>

                                                                                        {!isNaN(item.value) && !isNaN(parseFloat(item.value)) ?
                                                                                            <Radio.Group className="check_adcode_container"
                                                                                                value={item.condition}
                                                                                                onChange={(event) => { handleFilterCheckAdCodesCondition(event, "radio", index) }}
                                                                                            >
                                                                                                <Radio className="radio_btn check_adcode_radio" value="direct">
                                                                                                    Direct
                                                                                                </Radio>
                                                                                                <Radio className="radio_btn check_adcode_radio" value="regex">
                                                                                                    Regex
                                                                                                </Radio>
                                                                                            </Radio.Group>
                                                                                            :
                                                                                            <div className="primary_checkbox " >
                                                                                                <Checkbox id="case_sensitive" name="case_sensitive" className="check_adcode_checkbox"
                                                                                                    checked={item.condition === "case sensitive"}
                                                                                                    onChange={(event) => { handleFilterCheckAdCodesCondition(event, "checkbox", index) }}
                                                                                                >
                                                                                                    <span className="form_label">
                                                                                                        Case Sensitive Search
                                                                                                    </span>
                                                                                                </Checkbox>
                                                                                            </div>
                                                                                        }
                                                                                    </>
                                                                                    :
                                                                                    <>
                                                                                        <div className="primary_checkbox " >
                                                                                            <Checkbox id="case_sensitive" name="case_sensitive" className="check_adcode_checkbox"
                                                                                                checked={item.condition === "case sensitive"}
                                                                                                onChange={(event) => { handleFilterCheckAdCodesCondition(event, "checkbox", index) }}
                                                                                            >
                                                                                                <span className="form_label">
                                                                                                    Case Sensitive Search
                                                                                                </span>
                                                                                            </Checkbox>
                                                                                        </div>

                                                                                    </>
                                                                                }

                                                                            </>
                                                                        }
                                                                    </div>
                                                                </React.Fragment>
                                                            ))}

                                                            {tabView === 0 &&
                                                                <div className="check_adcodes_container">
                                                                    <img className="check_adcodes_add2" src={AddCodesAdd} alt="add" onClick={addFilterCheckAdCodes} />
                                                                </div>
                                                            }



                                                        </div>

                                                    </div>

                                                    <div className="action_button">
                                                        {buttonProcessingCheckAdcodes ?
                                                            <button
                                                                className="btn btn_primary mt-0 ms-3 w_fit_content submit loader"

                                                            >
                                                                <span>Submit</span>

                                                                <img
                                                                    src={loaderIcon}
                                                                    alt="USP"
                                                                    className="loader_icon"
                                                                />
                                                            </button>
                                                            :

                                                            <button className="btn btn_primary mt-0 ms-3 w_fit_content submit" type='button'
                                                                onClick={() => { handleSubmitCheckAdcodes() }}

                                                            >Submit</button>
                                                        }
                                                    </div>
                                                </div>

                                                <span className="error_content error_content_2">
                                                    {filterCheckAdcodesIsRequiredError && (
                                                        <> Please fill all input fields</>
                                                    )
                                                    }
                                                    {filterCheckAdcodesValidError && (
                                                        <> Invalid Domain</>
                                                    )
                                                    }
                                                </span>
                                            </div>
                                        </div>
                                        {data.length !== 0 &&
                                            <div ref={tableRef}>
                                                <Table
                                                    columns={tabView === 0 ? columnsAdDomain : tabView === 1 ? columnsOwnerDomain : columnsPartnerDomain}
                                                    pageSize={100}
                                                    dataSource={data.filter((item) =>
                                                        item.name?.toString().toLowerCase().includes(search.toLowerCase()) ||
                                                        item.status?.toString().toLowerCase().includes(search.toLowerCase()) ||
                                                        item.adcodes?.some(adcode =>
                                                            adcode.value?.toString().toLowerCase().includes(search.toLowerCase())
                                                        )
                                                    )}
                                                    pagination={false}
                                                    rowKey={(record) => record.id}
                                                    locale={locale}
                                                    scroll={{ x: 1000, y: 'calc(100vh - 42.2rem' }}
                                                    components={{
                                                        header: {
                                                            wrapper: () => <thead style={{ display: 'none' }} />,
                                                        },
                                                    }}
                                                />

                                            </div>
                                        }

                                    </div>


                                </>
                            }




                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default CTVConfigureAdcodes;
